import {
  Button,
  Modal,
} from "reactstrap";
import React, { useState } from "react";

import PropTypes from "prop-types";

const MessageDialog = ({isOpen,message,onConfirm,hide}) => {
  return (
    <>
      {
          <Modal
          isOpen={isOpen}
          scrollable={true}
          backdrop={"static"}
          centered={true}
        >
          <div className="modal-header">
            <h5 className="modal-title">Confirm</h5>
            {/* <button
              type="button"
              className="btn-close"
              onClick={() => onDelete(row)}
            ></button> */}
          </div>
          <div className="modal-body">
            <p className="mt-3">{message}</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success"
              onClick={() => onConfirm()}
            >
              <i className="fas fa-check"></i>&nbsp; Confirm
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => hide()}
            >
              <i className="fas fa-times"></i>
              &nbsp; Cancel
            </button>
          </div>
        </Modal>
      }
    </>
  )
}

MessageDialog.propTypes = {
  isOpen: PropTypes.bool,
  onConfirm: PropTypes.func,
  message: PropTypes.string,
  hide:PropTypes.func
};
export const useConfirmDialog = () => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [messageConfirm, setMessageConfirm] = useState(null);
  function toggleConfirm(message='Do you want to delete ?') {
    setMessageConfirm(message);
    setShowConfirm(!showConfirm);
  }
  return {
    showConfirm,
    toggleConfirm,
    messageConfirm,
  };
};

export default MessageDialog;